// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDjCFVgJKj7tySt_kEshRO-XUOuBMIpzrY",
  authDomain: "trust-flutter.firebaseapp.com",
  databaseURL: "https://trust-flutter-default-rtdb.firebaseio.com",
  projectId: "trust-flutter",
  storageBucket: "trust-flutter.firebasestorage.app",
  messagingSenderId: "225416987521",
  appId: "1:225416987521:web:fd1da89c53eed4f4d19e80"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
export const database = getDatabase(app);

export default app;
